// LICENSE : MIT
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Dispatcher_1 = require("./Dispatcher");
var shallow_equal_object_1 = require("shallow-equal-object");
var Events_1 = require("./Events");
/**
 * @type {string}
 * @private
 */
exports.defaultStoreName = "<Anonymous-Store>";
/**
 * Store hold the state of your application.
 *
 * Typically, `Store` has a parts of the whole state tree of your application.
 * `StoreGroup` is the the whole state tree.
 *
 * It means that `StoreGroup` is a collection of `Store` instances.
 *
 * A UseCase `dispatch(payload)` and `Store` can receive it.
 *
 * ### Abstraction Code
 *
 * This is imagination code. (It will not work.)
 *
 * ```js
 * abcUseCase
 *  .dispatch({
 *      type: "ABC",
 *      value: "value"
 *  });
 *
 * abcStore
 *  .onDispatch(payload => {
 *      console.log(payload.type);  // "ABC"
 *      console.log(payload.value); // 42
 *  });
 * ```
 *
 * We recommenced that implement `Store#receivePayload` insteadof using `Store#onDispatch`.
 * `Store#receivePayload` is almost same with `Store#onDispatch`.
 * But, `Store#receivePayload` is more match with Almin's life cycle.
 *
 * ### Example
 *
 * To implement store, you have to inherit `Store` class.
 *
 * ```js
 * class YourStore extends Store {
 *    constructor(){
 *       super();
 *       // Initialize state
 *       this.state = {
 *          foo : "bar"
 *       };
 *    }
 *
 *    // Update code here
 *    receivePayload(payload){
 *      this.setState(this.state.reduce(payload));
 *    }
 *
 *    getState(){
 *      return this.state;
 *    }
 * }
 * ```
 */
var Store = /** @class */ (function (_super) {
    __extends(Store, _super);
    /**
     * Constructor not have arguments.
     */
    function Store() {
        var _this = _super.call(this) || this;
        _this.stateChangeEvents = new Events_1.Events();
        var own = _this.constructor;
        /**
         * @type {string} Store name
         */
        _this.name = own.displayName || own.name || exports.defaultStoreName;
        return _this;
    }
    /**
     * Return true if the `v` is store like.
     */
    Store.isStore = function (v) {
        if (v instanceof Store) {
            return true;
        }
        else if (typeof v === "object" && typeof v.getState === "function" && typeof v.onChange === "function") {
            return true;
        }
        return false;
    };
    /**
     * Update own state property if needed.
     * If `this.shouldStateUpdate(currentState, newState)` return true, update `this.state` property with `newState`.
     */
    Store.prototype.setState = function (newState) {
        if (this.shouldStateUpdate(this.state, newState)) {
            this.state = newState;
            this.emitChange();
        }
    };
    /**
     * If the prev/next state is difference, should return true.
     *
     * Use Shallow Object Equality Test by default.
     * <https://github.com/sebmarkbage/ecmascript-shallow-equal>
     */
    Store.prototype.shouldStateUpdate = function (prevState, nextState) {
        return !shallow_equal_object_1.shallowEqual(prevState, nextState);
    };
    /**
     * Add `handler`(subscriber) to Store and return unsubscribe function
     * Store#onDispatch receive **only** dispatched the Payload by `UseCase#dispatch`.
     *
     * ### Example
     *
     * ```js
     * class MyStore extends Store {
     *   constructor(){
     *     super();
     *     this.unsubscribe = store.onDispatch((payload, meta) => {
     *         console.log(payload);
     *     });
     *     // ....
     * }
     * ```
     *
     * Some UseCase `dispatch` the payload and `Store#onDispatch` catch that.
     *
     * ```js
     * class MyUseCase extends UseCase{
     *   execute(){
     *     this.dispatch({
     *       type: "test"
     *     }); // => Store#onDispatch catch this
     * }
     * ```
     *
     */
    Store.prototype.onDispatch = function (handler) {
        return _super.prototype.onDispatch.call(this, handler);
    };
    /**
     * Subscribe change event of the store.
     * When `Store#emitChange()` is called, then call subscribers.
     *
     * ### Example
     *
     * ```js
     * store.onChange((changingStores) => {
     *    console.log(changingStores); // [store]
     * });
     *
     * store.emitChange();
     * ```
     */
    Store.prototype.onChange = function (handler) {
        return this.stateChangeEvents.addEventListener(handler);
    };
    /**
     * Emit "change" event to subscribers.
     * If you want to notify changing ot tha store, call `Store#emitChange()`.
     *
     * Basically, you should use `this.setState` insteadof `this.emitChange`
     */
    Store.prototype.emitChange = function () {
        this.stateChangeEvents.emit([this]);
    };
    /**
     * Release all event handlers
     */
    Store.prototype.release = function () {
        this.stateChangeEvents.removeAllEventListeners();
    };
    return Store;
}(Dispatcher_1.Dispatcher));
exports.Store = Store;
// Implement assertion
Store.prototype.getState = function () {
    throw new Error(this.name + " should be implemented Store#getState(): Object");
};
//# sourceMappingURL=Store.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/Store.js
// module id = 106
// module chunks = 0